import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';

export interface UpdateGeocodeDialogData {
  address: {id: string; latitude: any; longitude: any; geocodeBad: any};
}

@Component({
  selector: 'app-update-geocode-dialog',
  template: `
    <div class="modal">
    <div class="modal__body modal__body">
        <i class="fal fa-times modal__close" (click)="close(null)" data-test-id="closeUpdateGeocodeDialogBtn"></i>
        <h1 class="h2">Update Geocode</h1>
        <div class="vert-0050">
        <app-update-geocode [address]="data.address" (saved)="close($event)"></app-update-geocode>
        </div>
    </div>
</div>`
})
export class UpdateGeocodeDialogComponent {
  static open(dialog: MatDialog, config: MatDialogConfig<UpdateGeocodeDialogData>) {
    return dialog.open(UpdateGeocodeDialogComponent, config);
  }

  constructor(
    public dialogRef: MatDialogRef<UpdateGeocodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateGeocodeDialogData) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }
}
